import React from 'react';
import classNames from 'classnames';

import * as models from '../../../utils/models';
import css from './select.module.scss';

const Select: React.FC<models.SelectProps> = (props) => {
	const { name, label, options, error, ...rest } = props;

	const validClassName = React.useMemo(() => {
		let defaultClass: string = css['form-input-group-field'];
		if (error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	}, [error]);

	return (
		<div className={css['form-input-group']}>
			{label && <label htmlFor={name}>{label}</label>}

			<select
				{...rest}
				name={name}
				id={React.useId()}
				className={classNames({ [validClassName]: true })}
			>
				<option value="">{rest.placeholder}</option>

				{options.map((option: models.SelectOption) => (
					<option key={option.id} value={option.id}>
						{option.name}
					</option>
				))}
			</select>

			{error && <div className="error">{error}</div>}
		</div>
	);
};

export default Select;
